const CONTEXT_PAD_PADDING = 5;

/**
 * Custom context pad provider that positions the pad above the element
 */
export class CustomContextPadProvider {
    private _contextPad: any;

    static $inject = ['contextPad'];

    constructor(contextPad: any) {
        this._contextPad = contextPad;

        // Override the default positioning
        this._overridePositioning();
    }

    _overridePositioning() {
        const contextPad = this._contextPad;
        const originalOpen = contextPad.open.bind(contextPad);

        contextPad.open = (element: any, force?: boolean) => {
            originalOpen(element, force);

            // Use setTimeout to ensure the pad is rendered before repositioning
            setTimeout(() => {
                const pad = contextPad._current?.pad;
                if (pad && pad.html) {
                    const padElement = pad.html;

                    // Get element position in diagram coordinates
                    const elementX = element.x;
                    const elementY = element.y;
                    const elementWidth = element.width;

                    // Get pad width after render
                    const padWidth = padElement.offsetWidth || 200;
                    const padHeight = padElement.offsetHeight || 40;

                    // Position centered above the element
                    const newLeft = elementX + (elementWidth / 2) - (padWidth / 2);
                    const newTop = elementY - padHeight - CONTEXT_PAD_PADDING;

                    padElement.style.left = `${newLeft}px`;
                    padElement.style.top = `${newTop}px`;
                }
            }, 0);
        };
    }
}

export default {
    __init__: ['customContextPadProvider'],
    customContextPadProvider: ['type', CustomContextPadProvider]
};
